import { isDefined } from './helpers';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export function initPartenaires() {
    sliderPartenaires();
}

function sliderPartenaires()
{
    const slider = document.querySelector('.partenaires-slider');

    if(!isDefined(slider)) return;

    let sliderPartenaires = new Splide( slider, {
        type   : 'loop',
        drag   : 'free',
        focus  : 'center',
        pagination:false,
        waitForTransition: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        updateOnMove: true,
        perPage: 1,
        gap: 14,
        mediaQuery: 'min',
        arrows: false,
        autoScroll: {
            speed: 3,
        },
        breakpoints: {
            1190: 
            {
                perPage: 6,
            },
            800:
            {
                perPage: 3,
                autoScroll: {
                    speed: 2,
                },
            }

        }
    });

    sliderPartenaires.mount({AutoScroll});
}
